import React from 'react'
import { noop } from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl'
import { IconSend } from '@contrast-security-inc/design-system-foundations'
import { ActionButton } from '@contrast-security-inc/design-system-actions'
import { MenuAction } from '../../../../components/attack-events-grid/actions/menu-action'
import {
  PopoverMenu,
  MenuTrigger,
  MenuItem,
  Menu,
  Tooltip
} from '@contrast-security-inc/design-system-popovers'
import { LibraryAgentLanguage } from '../library/library-agent-language'

export const actionTestID = 'library-summary-send-action-icon'
export const rowActionTestId = `libraries-send-action-icon-`

export interface Library {
  hash: string
  language: LibraryAgentLanguage
  applications: Array<{ appId: string }>
}
export type SendActionMenuProps = {
  libraries: Library[]
  onSelectEmailOption: () => void
  onSelectBugtrackerOption: () => void
  renderIcon?: boolean
  popoverMenuKey?: string
  isPanel?: boolean
  bulk?: boolean
}

export const sendActionMenuBugTrackerTestId = 'send-bug-tracker-menu-option'
export const sendActionMenuEmailTestId = 'send-email-menu-option'

export function SendActionMenu({
  libraries,
  onSelectEmailOption,
  onSelectBugtrackerOption,
  renderIcon = true,
  popoverMenuKey,
  isPanel,
  bulk
}: SendActionMenuProps) {
  const { formatMessage } = useIntl()

  /** Bulk option not available on SendToBugTracker */
  const isBugTrackerDisabled = libraries.length > 1

  return (
    <PopoverMenu placement="left" id={popoverMenuKey}>
      <Menu>
        <MenuItem
          testId={sendActionMenuEmailTestId}
          onClick={onSelectEmailOption}
          itemID="email"
        >
          <FormattedMessage id="action_sendByEmail" />
        </MenuItem>
        <MenuItem
          testId={sendActionMenuBugTrackerTestId}
          itemID="bugtracker"
          onClick={!isBugTrackerDisabled ? onSelectBugtrackerOption : undefined}
          disabled={isBugTrackerDisabled}
        >
          <Tooltip
            enabled={isBugTrackerDisabled}
            body={formatMessage({
              id: 'detail_libraries_bulkBugTrackerNotAvailable'
            })}
          >
            <div>{formatMessage({ id: 'action_sendToBugTracker' })}</div>
          </Tooltip>
        </MenuItem>
      </Menu>
      <MenuTrigger>
        {({ isOpen }) =>
          renderIcon ? (
            <ActionButton
              data-testid={
                isPanel || libraries.length > 1 || bulk
                  ? actionTestID
                  : `${rowActionTestId}${libraries[0].hash}`
              }
              IconButtonProps={{
                Icon: IconSend,
                'aria-label': formatMessage({ id: 'action_send' })
              }}
              TooltipProps={{
                placement: 'top',
                body: formatMessage({ id: 'action_send' }),
                enabled: !isOpen
              }}
            />
          ) : (
            <MenuAction
              onClick={noop}
              i18nTitleId="action_libraries_sendLibrary"
            />
          )
        }
      </MenuTrigger>
    </PopoverMenu>
  )
}
